"use client";
import { j as a } from "./jsx-runtime-CJ-St4mQ.mjs";
import S from "react";
import l from "./Button.js";
import { t as R } from "./tv.config-BuYIgndg.mjs";
const y = R({
  base: ["Call-to-action__root flex align-baseline"],
  variants: {
    spacing: {
      8: "gap-2",
      16: "gap-4",
      24: "gap-8",
      32: "gap-10",
      48: "gap-12"
    },
    align: {
      left: "justify-start",
      right: "justify-end",
      center: "justify-center"
    },
    isResponsive: {
      true: ["sm:flex-row flex-col"]
    }
  }
}), A = S.forwardRef(
  function(e, t) {
    const {
      onCancel: s = () => {
      },
      onSave: i = () => {
      },
      onSaveLink: c,
      onCancelLink: r,
      onCancelLabel: f = "Cancel",
      onSaveLabel: u = "Save",
      size: n = "medium",
      spacing: m = "16",
      align: d = "left",
      color: o = "primary",
      isResponsive: C,
      className: v,
      onSaveColor: g,
      onCancelColor: j,
      onSaveHidden: p = !1,
      onCancelHidden: x = !1,
      component: b = "div"
    } = e;
    return !e.onSaveLabel && !e.onCancelLabel ? null : /* @__PURE__ */ a.jsxs(
      b,
      {
        ref: t,
        className: y({
          spacing: m,
          align: d,
          isResponsive: C,
          class: v
        }),
        children: [
          !p && /* @__PURE__ */ a.jsx(
            l,
            {
              autoFocus: !1,
              href: c,
              label: u,
              variant: "contained",
              color: g || o,
              onClick: i,
              size: n,
              className: "justify-center",
              render: e.onSaveRender
            }
          ),
          !x && /* @__PURE__ */ a.jsx(
            l,
            {
              autoFocus: !1,
              href: r,
              label: f,
              variant: "outlined",
              color: j || o,
              size: n,
              onClick: s,
              className: "justify-center",
              render: e.onCancelRender
            }
          )
        ]
      }
    );
  }
);
export {
  A as default
};
